const Director = "Director"
const Manager = "Manager"
const Analyst = "Analyst"
const SalesExecutive = "SalesExecutive"
const Financial = "Financial"
const Logistics = "Logistics"
const Seller = "Seller"
const CreditAnalyst = "CreditAnalyst"

export default [
  {
    path: "/shipping_rates/create",
    name: "CreateShippingRate",
    component: () => import("@/_backoffice/_registrations/components/shipping_rates/CreateShippingRate.vue"),
    meta: {
      auth: true,
      roles: [Director, Manager],
    },
  },
  {
    path: "/shipping_rates",
    name: "ShippingRates",
    component: () => import("@/_backoffice/_registrations/components/shipping_rates/ShippingRates.vue"),
    meta: {
      auth: true,
      roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
    },
  },
]
